import React, {useState} from 'react';
import CookieConsent, {Cookies} from 'react-cookie-consent';

const CookieConsentCustom = () => {
    const [preferences, setPreferences] = useState({
        necessary: true,
        preferences: true,
        marketing: true,
        analytics: true,
    });
    const [visible, setVisible] = useState(true);

    const handleAccept = () => {
        Cookies.set('cookiePreferences', preferences, {expires: 150});
        Cookies.set('lockedTradeCookie', true, {expires: 150});
        setVisible(false);
    };

    const handleToggle = (category) => {
        setPreferences((prev) => ({
            ...prev,
            [category]: !prev[category],
        }));
    };

    return (
        <div className={`cookie-consent-wrapper ${visible ? 'fade-in' : 'fade-out'}`}>
            <CookieConsent
                location="bottom"
                cookieName="lockedTradeCookie"
                style={{background: "#1F2939"}}
                buttonText="Accept"
                buttonStyle={{display: "none"}}
                expires={150}
            >
                <div className="cookie-consent-container generic-container">
                    <div className="cookie-consent-left-side">
                        This website uses cookies to enhance the user experience.
                        <div className="flex gap-4 flex-wrap justify-center">
                            <label className="flex gap-1">
                                <input
                                    type="checkbox"
                                    checked={preferences.necessary}
                                    disabled
                                />
                                Necessary
                            </label>
                            <label className="flex gap-1">
                                <input
                                    type="checkbox"
                                    checked={preferences.preferences}
                                    onChange={() => handleToggle('preferences')}
                                />
                                Preferences
                            </label>
                            <label className="flex gap-1">
                                <input
                                    type="checkbox"
                                    checked={preferences.marketing}
                                    onChange={() => handleToggle('marketing')}
                                />
                                Marketing
                            </label>
                            <label className="flex gap-1">
                                <input
                                    type="checkbox"
                                    checked={preferences.analytics}
                                    onChange={() => handleToggle('analytics')}
                                />
                                Analytics
                            </label>
                        </div>
                    </div>
                    <div className="cookie-consent-right-side">
                        <button
                            onClick={handleAccept}
                            className="small-button white-variant"
                        >
                            Accept
                        </button>
                    </div>
                </div>
            </CookieConsent>
        </div>
    );
}

export default CookieConsentCustom;